import {Component, OnInit} from '@angular/core';
import { MatButton } from "@angular/material/button";
import {
  MatCard,
  MatCardContent,
  MatCardHeader,
  MatCardTitle
} from "@angular/material/card";
import { DocumentsOfferingService } from "../../services/documents-offering.service";
import { ToastrService } from "ngx-toastr";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatIcon } from "@angular/material/icon";
import { MatFormField } from "@angular/material/form-field";
import { MatLabel} from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatDivider } from "@angular/material/divider";
import { DatePipe } from "@angular/common";
import { CodeMaskDirective } from "../../_directives/code-mask.directive";

@Component({
  selector: 'app-validation-document',
  standalone: true,
  imports: [
    MatButton,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    FormsModule,
    ReactiveFormsModule,
    MatCardContent,
    MatIcon,
    MatFormField,
    MatLabel,
    MatInputModule,
    MatDivider,
    CodeMaskDirective
  ],
  templateUrl: './validation-document.component.html',
  styleUrl: './validation-document.component.css',
  providers: [DatePipe]
})
export class ValidationDocumentComponent implements OnInit{
  validationForm!: FormGroup;
  validationData: any = null;
  errorMessage: string = '';

  constructor(private fb: FormBuilder, private courseOfferingService: DocumentsOfferingService, private toastService: ToastrService, private datePipe: DatePipe) {
    this.validationForm = this.fb.group({
      code: ['', [Validators.required, Validators.minLength(19)]]
    });
  }

  ngOnInit(): void {
    this.validationForm.get('code')?.valueChanges.subscribe(value => {
      if (value && !this.isValidCode(value)) {
        this.validationData = null;
        this.errorMessage = '';
      }
    });
  }

  isValidCode(code: string): boolean {
    const codePattern = /^([A-Za-z0-9]{4}-){3}[A-Za-z0-9]{4}$/;
    return codePattern.test(code);
  }

  onSubmit(): void {
    if (this.validationForm.valid) {
      const code = this.validationForm.value.code;
      this.courseOfferingService.checkCode(code).subscribe(
        (response) => {
          if (response.message === 'Documento vÃ¡lido') {
            this.validationData = response;
            if (this.validationData.documentDate) {
              this.validationData.documentDateFormatted = this.datePipe.transform(this.validationData.documentDate, 'dd/MM/yyyy');
            }
            this.toastService.success('Documento vÃ¡lido!', 'Sucesso');
          }
        },
        (errorMessage) => {
          this.toastService.error(errorMessage);
        }
      );
    }
  }
}
